module.exports = __webpack_public_path__ + "img/loading.030dcdc3.svg";